/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ItineraryProjection
 */
export interface ItineraryProjection {
    /**
     * Unique identifier for the itinerary
     * @type {string}
     * @memberof ItineraryProjection
     */
    id: string;
    /**
     * Number of likes for this itinerary
     * @type {number}
     * @memberof ItineraryProjection
     */
    likeCount: number;
    /**
     * URL of the itinerary image
     * @type {string}
     * @memberof ItineraryProjection
     */
    imageUrl: string | null;
    /**
     * Title of the itinerary
     * @type {string}
     * @memberof ItineraryProjection
     */
    title: string;
    /**
     * Number of days in this itinerary
     * @type {number}
     * @memberof ItineraryProjection
     */
    daysCount: number;
    /**
     * Number of stops in this itinerary
     * @type {number}
     * @memberof ItineraryProjection
     */
    stopsCount: number;
    /**
     * Username of the itinerary creator
     * @type {string}
     * @memberof ItineraryProjection
     */
    accountUserName: string;
    /**
     * URL of the primary country image for this itinerary
     * @type {string}
     * @memberof ItineraryProjection
     */
    countryImageUrl: string | null;
}

/**
 * Check if a given object implements the ItineraryProjection interface.
 */
export function instanceOfItineraryProjection(value: object): value is ItineraryProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('likeCount' in value) || value['likeCount'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('daysCount' in value) || value['daysCount'] === undefined) return false;
    if (!('stopsCount' in value) || value['stopsCount'] === undefined) return false;
    if (!('accountUserName' in value) || value['accountUserName'] === undefined) return false;
    if (!('countryImageUrl' in value) || value['countryImageUrl'] === undefined) return false;
    return true;
}

export function ItineraryProjectionFromJSON(json: any): ItineraryProjection {
    return ItineraryProjectionFromJSONTyped(json, false);
}

export function ItineraryProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItineraryProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'likeCount': json['likeCount'],
        'imageUrl': json['imageUrl'],
        'title': json['title'],
        'daysCount': json['daysCount'],
        'stopsCount': json['stopsCount'],
        'accountUserName': json['accountUserName'],
        'countryImageUrl': json['countryImageUrl'],
    };
}

  export function ItineraryProjectionToJSON(json: any): ItineraryProjection {
      return ItineraryProjectionToJSONTyped(json, false);
  }

  export function ItineraryProjectionToJSONTyped(value?: ItineraryProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'likeCount': value['likeCount'],
        'imageUrl': value['imageUrl'],
        'title': value['title'],
        'daysCount': value['daysCount'],
        'stopsCount': value['stopsCount'],
        'accountUserName': value['accountUserName'],
        'countryImageUrl': value['countryImageUrl'],
    };
}

